import React, { useEffect, useCallback, useState, useRef } from 'react';
import { useLocation, history, useDispatch } from 'umi';
import qs from 'qs';
import dayjs from 'dayjs';
import AddIcon from '@material-ui/icons/Add';
import { Fab, Box } from '@material-ui/core';
import { OPT_ADD } from '@/constants';
import ResultList from './components/result_list/ResultList';
import SearchGroup from './components/search_group/SearchGroup';
import webStorage from '@/utils/storageManager';
import LuckyDrawStyled from './luckyDrawStyles';

export default () => {
  const MENU_MARKETING_LOTTERY_ADD = webStorage
    .get('USER')
    ?.authorities?.includes('MENU_MARKETING_LOTTERY_ADD');
  const dispatch = useDispatch();
  const location = useLocation();
  const { query, pathname } = location;
  const [isSearch, setIsSearch] = useState(false);
  const searchRef = useRef();
  // 结构到所有查询条件，包括分页条件
  const {
    status,
    name,
    beginDateTime,
    endDateTime,
    refreshTime,
    pageNum = '1',
    pageSize = '10',
  } = query;

  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        refreshTime: time,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: 1,
      })}`,
    );
  };
  //活动列表
  const fetchActivityList = useCallback(() => {
    const values = {
      name,
      status,
      beginDateTime,
      endDateTime,
      refreshTime,
      searchCount: true,
      pageNum,
      pageSize,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'luckyDraw/getDrawList',
      payload: {
        values,
      },
    });
  }, [
    beginDateTime,
    dispatch,
    endDateTime,
    name,
    pageNum,
    pageSize,
    refreshTime,
    status,
  ]);

  useEffect(() => {
    fetchActivityList();
  }, [fetchActivityList]);

  const handleToBenefitVoucher = () => {
    history.push({
      pathname: '/marketing/luck_draw_view/luck_draw_view_setting_add',
      query: {
        opt: OPT_ADD,
        sourceOid: 'btn_marketing_activity_lottery_list_create',
      },
    });
  };

  return (
    <LuckyDrawStyled>
      <Box
        data-log={JSON.stringify({
          oid: 'page_marketing_activity_lottery_list',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
        sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <SearchGroup
          searchRef={searchRef}
          query={query}
          handleSearch={(searchParam) => handleSearch(searchParam)}
          restClick={handleRestClick}
        />
        <div className="export-wrapper">
          <Fab
            data-log={JSON.stringify({
              oid: 'btn_marketing_activity_lottery_list_create',
              events: ['_ev', '_ec'],
              params: {
                initUrl: window.location.origin + window.location.pathname,
              },
            })}
            variant="extended"
            size="small"
            color="primary"
            aria-label="add"
            className="export"
            sx={{ marginRight: '16px' }}
            disabled={!MENU_MARKETING_LOTTERY_ADD}
            onClick={() => handleToBenefitVoucher()}
          >
            <AddIcon sx={{ width: '24px', height: '24px' }} />
            新建活动
          </Fab>
        </div>
        <div style={{ flexGrow: 1 }} className="">
          <ResultList
            pageData={{ pageNum, pageSize }}
            handlePageChange={handlePageChange}
          />
        </div>
      </Box>
    </LuckyDrawStyled>
  );
};
